import { getErrorMessage } from '../errors/errors';
/**
 * @deprecated Use `Logger.error` instead
 */
export const logError = (args) => error(args);
const http = ({ method, path, data }) => {
    if (data) {
        console.log({
            http: { method: method, url: path },
            message: `▶️ ${method || '<NONE>'} ${path || '<NONE>'}`,
            data
        });
    }
    else {
        console.log({
            http: { method: method, url: path },
            message: `▶️ ${method || '<NONE>'} ${path || '<NONE>'}`
        });
    }
};
const log = ({ context, message, object }) => {
    if (object) {
        console.log(`[${context}] ${message}`, object);
    }
    else {
        console.log(`[${context}] ${message}`);
    }
};
const debug = ({ context, message, object }) => {
    if (object) {
        console.debug(`🔎 [${context}] ${message}`, object);
    }
    else {
        console.debug(`🔎 [${context}] ${message}`);
    }
};
const info = ({ context, message, object }) => {
    if (object) {
        console.info(`ℹ️ [${context}] ${message}`, object);
    }
    else {
        console.info(`ℹ️ [${context}] ${message}`);
    }
};
const warn = ({ context, message, object }) => {
    if (object) {
        console.warn(`🚧 [${context}] ${message}`, object);
    }
    else {
        console.warn(`🚧 [${context}] ${message}`);
    }
};
const error = ({ context, message, error, object }) => {
    if (object) {
        console.error(`🚨 [${context}] ${message}. Error: ${getErrorMessage(error)}`, error, object);
    }
    else {
        console.error(`🚨 [${context}] ${message}. Error: ${getErrorMessage(error)}`, error);
    }
};
export const Logger = {
    http,
    log,
    debug,
    info,
    warn,
    error
};
//# sourceMappingURL=logger.js.map